import { render } from "./NewReminder.vue?vue&type=template&id=47d1fca1&scoped=true"
import script from "./NewReminder.vue?vue&type=script&lang=js"
export * from "./NewReminder.vue?vue&type=script&lang=js"

import "./NewReminder.vue?vue&type=style&index=0&id=47d1fca1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d1fca1"]])

export default __exports__